/**
 * Preview Container view
 *
 * Action types for real material render button, shapejs view and slidshow.
 */
var sw = require('js/lib/sw');
var ShapewaysView = require('./ShapewaysView');
var productViewActionCreators = require('js/lib/actions/ProductViewPage/actionCreators');
var shapeJSRTActionCreators = require('js/lib/actions/ShapeJSRT/actionCreators');

var PreviewContainer = ShapewaysView.extend({

  swAttrs: {
    realMaterialButton: 'data-sw-preview-container-real-material-render-button',
    realMaterialIcon: 'data-sw-preview-container-real-material-render-icon',
    productSlideshow: 'data-sw-preview-container-product-slideshow',
    realMaterialRender: 'data-sw-preview-container-real-material-render'
  },

  swSelectors: {
    realMaterialRenderViewer: '[data-sw-shapejs-viewer="realMaterialRender"]'
  },

  viewDefaults: {
    isRealMaterialRenderActivate: false,
    isRealMaterialRenderActive: false
  },

  events: function () {

    var eventsHash = {
      'click [data-sw-preview-container-real-material-render-button]': 'onRealMaterialRenderButtonClick'
    };

    return eventsHash;
  },

  initialize: function (options) {
    this.shapeJsId = options.shapeJsId;

    this.listenTo(this.model, 'change:isRealMaterialRenderAvailable', this.updateRealMaterialRenderAvailable, this);
    this.listenTo(this.model, 'change:currentConfigurationId', this.updatePreviewContainerView, this);
    this.listenTo(this.model, 'change:isRealMaterialRenderLoading', this.updateShapeJsViewerLoading, this);
  },

  /**
   * Change shapejs params when select different material
   */
  dispatchSelectMaterialShapeJsAction: function dispatchSelectMaterialShapeJsAction() {
    if (this.model.isRealMaterialRenderCanShow()) {
      sw.dispatch(shapeJSRTActionCreators.selectMaterialShapeJs(this.shapeJsId, this.model.getMaterialAbbreviation(), this.model.isFullColorMaterial(), this.model.getCurrentModel()));
    }
  },

  /**
   * Update real material render button icon based on current states.
   * Update shapejs viewer and image slideshow show/hide based on current states
   */
  updatePreviewContainerView: function updatePreviewContainerView() {
    this.dispatchSelectMaterialShapeJsAction();
    this.updateRealMaterialRenderButton();
    this.updateShapeJsViewerAndImageSlideshow();
  },

  /**
   * Click on button will activate shape js and update views inside preview container based on current states.
   */
  onRealMaterialRenderButtonClick: function onRealMaterialRenderButtonClick() {
    if (this.model.isRealMaterialRenderCanShow()) {
      sw.dispatch(productViewActionCreators.activateShapeJs(this.shapeJsId));
      if (this.state.get('isRealMaterialRenderActive')) {
        this.state.set({
          isRealMaterialRenderActive: false
        });
        sw.dispatch(productViewActionCreators.shapeJsIsActive(this.shapeJsId, false));
      } else {
        this.state.set({
          isRealMaterialRenderActive: true
        });
        sw.dispatch(productViewActionCreators.shapeJsIsActive(this.shapeJsId, true));
      }
      this.updatePreviewContainerView();
      if (!this.state.get('isRealMaterialRenderActivate')) {
        sw.dispatch(productViewActionCreators.shapeJsIsLoading(this.model.id, true));
      }
    }
  },

  /**
   * Based on current states, button will become hide/show.
   */
  updateRealMaterialRenderAvailable: function updateRealMaterialRenderAvailable() {
    if (this.model.get('isRealMaterialRenderAvailable') && this.model.isRealMaterialRenderCanShow()) {
      this.cachedElements.$realMaterialButton.addClass('sw-preview-container__real-material-render-button--popin-second sw-preview-container__real-material-render-button--hover');
    } else {
      this.cachedElements.$realMaterialButton.addClass('sw--is-hidden');
    }
    this.updateRealMaterialRenderButton();
  },

  /**
   * Based on current states, button will become clickable/unclickable and symbol/close icon.
   */
  updateRealMaterialRenderButton: function updateRealMaterialRenderButton() {
    var symbolClass = 'sw-preview-container__real-material-render-icon--symbol';
    var closeClass = 'sw-preview-container__real-material-render-icon--close';
    if (this.model.isRealMaterialRenderCanShow() && this.state.get('isRealMaterialRenderActive')) {
      this.cachedElements.$realMaterialIcon.attr('src', '/rrstatic/img/rmr-close.svg');
      this.cachedElements.$realMaterialIcon.removeClass(symbolClass);
      this.cachedElements.$realMaterialIcon.addClass(closeClass);
    } else {
      this.state.set({isRealMaterialRenderActive: false});
      this.cachedElements.$realMaterialIcon.attr('src', '/rrstatic/img/rmr-3d-icon.svg');
      this.cachedElements.$realMaterialIcon.removeClass(closeClass);
      this.cachedElements.$realMaterialIcon.addClass(symbolClass);
    }
  },

  /**
   * Based on current states, shapejs viewer and image slideshow will hide/show and interactive/non-interactive.
   */
  updateShapeJsViewerAndImageSlideshow: function updateShapeJsViewerAndImageSlideshow() {
    if (this.state.get('isRealMaterialRenderActive')) {
      this.$el.addClass('sw-preview-container--show-shapejs-viewer');
    } else {
      this.$el.removeClass('sw-preview-container--show-shapejs-viewer');
    }
  },

  /**
   * Base on current states, shapejs viewer will show loading spinner or not
   */
  updateShapeJsViewerLoading: function updateShapeJsViewerLoading() {
    if (!this.state.get('isRealMaterialRenderActivate') && this.model.get('isRealMaterialRenderLoading')) {
      this.cachedElements.$realMaterialRender.swShowLoading();
      this.state.set({isRealMaterialRenderActivate: true});
    } else {
      this.cachedElements.$realMaterialRender.swHideLoading();
    }
  }

});

module.exports = PreviewContainer;
